import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserContext = /*#__PURE__*/React.createContext(undefined);
export const UserContextProvider = _ref => {
  let {
    children,
    user
  } = _ref;
  return /*#__PURE__*/_jsx(UserContext.Provider, {
    value: user,
    children: children
  });
};
export const UserContextConsumer = UserContext.Consumer;